import React from "react";
import styled from "styled-components/macro";

export default function ElectricHall(props) {
    const {electricStandard: electricStandart}= props;
  return (
    <>
      {electricStandart === "standard" && (
        <Wrapper bottom={25} right={25}>
          <Circle />
          <VerticalLine left={7} top={8} height={18} />
          <HorizontallLine width={18} left={8} />
        </Wrapper>
      )}
      {electricStandart === "2 standard" && (
        <>
          <Wrapper bottom={25} right={25}>
            <Circle />
            <VerticalLine left={7} top={8} height={18} />
            <HorizontallLine width={18} left={8} />
          </Wrapper>

          <Wrapper bottom={25} left={12}>
            <Circle />
            <VerticalLine left={7} top={8} height={18} />
            <HorizontallLine width={18} left={-11} />
          </Wrapper>
        </>
      )}
      {electricStandart === "vacuum cleaner" && (
        <>
          <Wrapper top={100} right={55}>
            <Circle />
            <VerticalLine left={7} top={-100} height={108} />
            <HorizontallLine width={48} left={8} />
          </Wrapper>

          <Wrapper top={100} left={40}>
            <Circle />
            <VerticalLine left={7} top={-100} height={108} />
            <HorizontallLine width={48} left={-41} />
          </Wrapper>
        </>
      )}
      {electricStandart === "printer" && (
        <Wrapper bottom={25} right={95}>
          <Circle />
          <VerticalLine left={7} top={8} height={18} />
        </Wrapper>
      )}
      {electricStandart === "fridge" &&"freezer"   &&
        <>
          <Wrapper top={5} left={45}>
            <Ellipse />
            <VerticalLine left={43} top={-6} height={18} />
          </Wrapper>
          <Wrapper bottom={25} left={45}>
            <Ellipse />
            <VerticalLine left={43} top={8} height={18} />
          </Wrapper>
        </>
      }
    </>
  );
}

const Wrapper = styled.div`
  position: absolute;
  bottom: ${(props) => props.bottom}px;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  right: ${(props) => props.right}px;
`;
const Circle = styled.div`
  width: 16px;
  height: 16px;
  background-color: gray;
  border: black solid 2px;
  border-radius: 50%;
  position: absolute;
`;
const VerticalLine = styled.div`
  width: 1px;
  height: ${(props) => props.height}px;
  position: absolute;
  border-right: black dashed 2px;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
`;
const HorizontallLine = styled.div`
  height: 1px;
  width: ${(props) => props.width}px;
  position: absolute;
  border-top: black dashed 2px;
  top: 8px;
  left: ${(props) => props.left}px;
`;

const Ellipse = styled.div`
  width: 86px;
  height: 20px;
  background-color: gray;
  border: black solid 1px;
  border-radius: 20px;
  position: absolute;
`;
